import { connect } from 'react-redux'
import { IStoreState } from '../../types/index'
import AddVehicleTypeModal from 'src/components/global-settings/AddVehicleTypeModal'
import { createVehicleType, getVehicleCreateOptions } from 'src/state/actions/vehicles'

const mapStateToProps = (state: IStoreState, ownProps: any): any => {
  return {}
}

const mapDispatchToProps = (dispatch: any): any => {
  return {
    createVehicleType: (name: string) => {
      return new Promise((approve, reject) => {
        dispatch(createVehicleType(name)).then(() => {
          dispatch(getVehicleCreateOptions()).then(() => {
            approve()
          })
        })
      })
    },
    getVehicleCreateOptions: () => dispatch(getVehicleCreateOptions())
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddVehicleTypeModal)



// WEBPACK FOOTER //
// ./src/containers/global-settings/AddVehicleTypeModal.ts